"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cryptoSymbol = void 0;

var _constants = require("./0_constants");

var _utils = require("./0_utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** this function add new pair and create lookup methods
 * @param {object} newPair add new pair of crypto symbol { name:symbol }, place {} if no new pair to add
 * @returns methods
 */
var cryptoSymbol = function cryptoSymbol(newPair) {
  var NSPair = _objectSpread(_objectSpread({}, _constants.symbolLookupObject), newPair);

  var SNPair = (0, _utils.swapKeyAndValue)(NSPair);
  var SNPairTrimmed = (0, _utils.trimAndLowerKeyCase)(SNPair);
  var NSPairTrimmed = (0, _utils.trimAndLowerKeyCase)(NSPair);
  return {
    /** this function return all pairs object
     * @returns {
    	NSPair: name-symbol pair,
    	SNPair: symbol-name pairs,
    }
     */
    get: function get() {
      return {
        NSPair: NSPair,
        SNPair: SNPair
      };
    },

    /** this function search name based on the input symbol
     * @param {string} symbolString symbol that you want to search name for
     * @param {{exact:boolean, allow:string} | undefined } exact set this to true if you want exact match, "allow" whitelist the character you dont want to ignore
     * @returns {string | undefined} name of the coin
     */
    nameLookup: function nameLookup(symbolString) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        exact: false,
        allow: ''
      };
      return config.exact ? SNPair[symbolString] : SNPairTrimmed[(0, _utils.onlyAlphaNumeric)(symbolString, config.allow)];
    },

    /** this function search symbol based on the input name
     * @param {string} nameString name that you want to search symbol for
     * @param {{exact:boolean, allow:string} | undefined } exact set this to true if you want exact match, "allow" whitelist the character you dont want to ignore
     * @returns {string | undefined} symbol of the coin
     */
    symbolLookup: function symbolLookup(nameString) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        exact: false,
        allow: ''
      };
      return config.exact ? NSPair[nameString] : NSPairTrimmed[(0, _utils.onlyAlphaNumeric)(nameString, config.allow)];
    }
  };
};

exports.cryptoSymbol = cryptoSymbol;